"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../../../../Types");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var AuthenticationService_1 = require("../../../../../Services/AuthenticationService");
var Util_1 = require("../../../../../Services/Util");
var Components_1 = require("../../../../../Components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var EventHandlerService_1 = require("../../../../../Services/EventHandlerService");
var Components_2 = require("../../../../../Components");
function EditUserEvent(updateCallback, user, resources, locations) {
    var _this = this;
    var editUserEventContentRef = React.createRef();
    return new Types_1.VeriLiteInformationEvent(React.createElement(EditUserEventContent, { ref: editUserEventContentRef, updateCallback: updateCallback, user: user, resources: resources, locations: locations }), resources.EditUser, [
        new Types_1.VeriLiteEventAction(resources.Save, "primary", function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                (_b = (_a = editUserEventContentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.editUser();
                return [2 /*return*/];
            });
        }); }, true),
        new Types_1.VeriLiteEventAction(resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
            closeModalCallback();
        })
    ]);
}
exports.EditUserEvent = EditUserEvent;
var InputValidationState;
(function (InputValidationState) {
    InputValidationState[InputValidationState["unset"] = 0] = "unset";
    InputValidationState[InputValidationState["invalid"] = 1] = "invalid";
    InputValidationState[InputValidationState["valid"] = 2] = "valid";
})(InputValidationState || (InputValidationState = {}));
var EditUserEventContentState;
(function (EditUserEventContentState) {
    EditUserEventContentState[EditUserEventContentState["Initial"] = 0] = "Initial";
    EditUserEventContentState[EditUserEventContentState["Pending"] = 1] = "Pending";
    EditUserEventContentState[EditUserEventContentState["Success"] = 2] = "Success";
    EditUserEventContentState[EditUserEventContentState["Error"] = 3] = "Error";
})(EditUserEventContentState || (EditUserEventContentState = {}));
var userRoles = function (resources) { return [{
        value: "User",
        label: resources.User,
        isDisabled: true,
        isFixed: true
    }, {
        value: "Administrator",
        label: resources.Administrator,
        isDisabled: false,
        isFixed: false
    }, {
        value: "SuperUser",
        label: resources.SuperUser,
        isDisabled: true,
        isFixed: true
    }]; };
var customStyles = {
    container: function (provided) { return (__assign(__assign({}, provided), { flex: '1 1' })); },
    control: function (provided) { return (__assign(__assign({}, provided), { borderRadius: "0px 4px 4px 0px" })); }
};
var EditUserEventContent = /** @class */ (function (_super) {
    __extends(EditUserEventContent, _super);
    function EditUserEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.error = {};
        _this.isValid = function (input) {
            return input === InputValidationState.valid;
        };
        _this.isInvalid = function (input) {
            return input === InputValidationState.invalid;
        };
        _this.isFormValid = function () {
            var validationResult = true;
            for (var key in _this.state.UserDataValidation) {
                validationResult = validationResult && _this.state.UserDataValidation[key].State != InputValidationState.invalid;
            }
            return validationResult;
        };
        _this.clearValidation = function () {
            console.error("undefined method clearValidation");
        };
        _this.validateInput = function (inputName) {
            //console.log(`validate ${inputName}`)
            var error = "";
            var state = InputValidationState.unset;
            if (typeof _this.state.UserData[inputName] !== "string" || _this.state.UserData[inputName] === undefined || _this.state.UserData[inputName] === null || _this.state.UserData[inputName] === "") {
                error = _this.props.resources.Registration_Validation_RequiredField;
                state = InputValidationState.invalid;
            }
            else {
                state = InputValidationState.valid;
                if (inputName == "DisplayName") {
                    if (!/^\S+.{1,}\S$/.test(_this.state.UserData[inputName])) {
                        error = _this.props.resources.InvalidDisplayName;
                        state = InputValidationState.invalid;
                    }
                    if (_this.state.UserData[inputName].length > 30) {
                        error = _this.props.resources.DisplayNameTooLong;
                        state = InputValidationState.invalid;
                    }
                }
            }
            return { State: state, Error: error };
        };
        _this.updateUserData = function (event, propName) {
            var _a;
            _this.setState({
                UserData: __assign(__assign({}, _this.state.UserData), (_a = {}, _a[propName] = event.target.value, _a))
            }, function () {
                var _a;
                var validationData = _this.validateInput(propName);
                _this.setState({
                    UserDataValidation: __assign(__assign({}, _this.state.UserDataValidation), (_a = {}, _a[propName] = validationData, _a))
                }, function () {
                    _this.updateSaveButtonStatus();
                });
            });
        };
        _this.updateValidation = function (validationResponse) {
            _this.clearValidation();
            _this.setState({ ApplicationValidation: { Error: validationResponse, State: InputValidationState.invalid } });
        };
        _this.editUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var user, options, json, userRequestHeaders, headers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = this.state.UserData;
                        this.updateModal(EditUserEventContentState.Pending);
                        options = {};
                        options = Object.assign(__assign({}, Util_1.defaultPostOptions), options);
                        json = JSON.stringify({ user: user, roles: this.state.roles });
                        options = __assign(__assign({}, options), { body: json });
                        userRequestHeaders = new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser());
                        headers = new Headers(options.headers);
                        return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                                headers.append("Authorization", "Bearer " + token);
                                options.headers = headers;
                            }).catch(function (error) {
                                console.error("Error adding auth header: " + error);
                            })];
                    case 1:
                        _a.sent();
                        userRequestHeaders.AppendHeaders(options);
                        fetch("/users/UpdateUser", options).then(function (response) {
                            if (!response.ok) {
                                switch (response.status) {
                                    case 400:
                                        _this.updateModal(EditUserEventContentState.Initial);
                                        response.json().then(function (validationResponse) {
                                            _this.updateValidation(validationResponse);
                                        });
                                        break;
                                    case 402:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(EditUserEventContentState.Error);
                                        });
                                        break;
                                    case 500:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(EditUserEventContentState.Error);
                                        }).catch(function () {
                                            _this.error.title = _this.props.resources.Error;
                                            _this.error.detail = _this.props.resources.ServerErrorMessage;
                                            _this.updateModal(EditUserEventContentState.Error);
                                        });
                                        break;
                                    default:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(EditUserEventContentState.Error);
                                        }).catch(function () {
                                            _this.error.title = _this.props.resources.Error;
                                            _this.error.detail = _this.props.resources.UnknownErrorMessage;
                                            _this.updateModal(EditUserEventContentState.Error);
                                        });
                                        break;
                                }
                            }
                            else {
                                _this.updateModal(EditUserEventContentState.Success);
                            }
                        }).catch(function (err) {
                            _this.error.title = _this.props.resources.Error;
                            _this.error.detail = _this.props.resources.UnknownErrorMessage;
                            _this.updateModal(EditUserEventContentState.Error);
                            console.error("Error updating user:");
                            console.error(err);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateModal = function (newState) {
            _this.setState({ status: newState });
            switch (newState) {
                case EditUserEventContentState.Success:
                    _this.props.updateCallback();
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.Success;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Finish, "primary", function (_currentEvent, closeModalCallback) { closeModalCallback(); })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case EditUserEventContentState.Error:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.error.title || _this.props.resources.Error;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case EditUserEventContentState.Pending:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.LoadingDotDotDot;
                    event.actions = [];
                    eventHandler.UpdateEvent();
                    break;
                case EditUserEventContentState.Initial:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.EditUserTitle;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Save, "primary", function (currentEvent, closeModalCallback) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.editUser();
                                return [2 /*return*/];
                            });
                        }); }),
                        new Types_1.VeriLiteEventAction(_this.props.resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
            }
        };
        _this.unsetValidation = function (inputName) {
            if (_this.state.UserDataValidation[inputName].State == InputValidationState.valid) {
                var validationState = _this.state.UserDataValidation;
                validationState[inputName].State = InputValidationState.unset;
                _this.setState({ UserDataValidation: validationState });
            }
        };
        _this.selectOnChange = function (value) {
            var userRoles = "";
            for (var i = 0; i < value.length; i++) {
                userRoles += value[i].value;
                if (i + 1 < value.length) {
                    userRoles += ", ";
                }
            }
            _this.setState({ UserRoleSelectOptions: value, roles: userRoles }, function () {
                _this.updateSaveButtonStatus();
            });
        };
        _this.updateSaveButtonStatus = function () {
            var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
            var event = eventHandler.GetEvent();
            //Assuming the save button is action 0
            if (event.actions[0].isDisabled && _this.isFormValid()) {
                event.actions[0].isDisabled = false;
                eventHandler.UpdateEvent();
            }
            else if (!event.actions[0].isDisabled && !_this.isFormValid()) {
                event.actions[0].isDisabled = true;
                eventHandler.UpdateEvent();
            }
            //Save button will be disabled, if no change has been made
            if (_this.props.user.displayName == _this.state.UserData.DisplayName && _this.props.user.defaultLocation == _this.state.UserData.DefaultLocation && _this.props.user.twoFactorAuthentication == _this.state.UserData.TwoFactorAuthentication && _this.props.user.userRole == _this.state.roles) {
                event.actions[0].isDisabled = true;
                eventHandler.UpdateEvent();
            }
        };
        _this.stateBasedRender = function (currentState) {
            switch (currentState) {
                case EditUserEventContentState.Initial:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null, _this.props.resources.DisplayName)),
                            React.createElement(reactstrap_1.Input, { valid: _this.isValid(_this.state.UserDataValidation.DisplayName.State), invalid: _this.isInvalid(_this.state.UserDataValidation.DisplayName.State), onChange: function (e) { return _this.updateUserData(e, "DisplayName"); }, value: _this.state.UserData.DisplayName, onBlur: function () { _this.unsetValidation("DisplayName"); } }),
                            React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, _this.isInvalid(_this.state.UserDataValidation.DisplayName.State) ? _this.state.UserDataValidation.DisplayName.Error : "")),
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null, _this.props.resources.DefaultLocation)),
                            React.createElement(reactstrap_1.Input, { type: "select", onChange: function (e) { return _this.updateUserData(e, "DefaultLocation"); }, value: _this.state.UserData.DefaultLocation }, _this.props.locations.map(function (location) {
                                return React.createElement("option", { key: location.Name, value: location.Name }, location.Name);
                            }))),
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null, _this.props.resources.TwoFactorAuthentication)),
                            React.createElement(reactstrap_1.Input, { type: "select", onChange: function (e) { return _this.updateUserData(e, "TwoFactorAuthentication"); }, value: "" + _this.state.UserData.TwoFactorAuthentication },
                                React.createElement("option", { key: _this.props.resources.Disabled, value: "false" }, _this.props.resources.Disabled),
                                React.createElement("option", { key: _this.props.resources.Enabled, value: "true" }, _this.props.resources.Enabled))),
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null, _this.props.resources.Registration_Role)),
                            React.createElement(Components_2.MultiSelect, { styles: customStyles, options: _this.state.SelectOptions, onChange: _this.selectOnChange, initialValue: _this.state.UserRoleSelectOptions })),
                        _this.isInvalid(_this.state.ApplicationValidation.State) && React.createElement(reactstrap_1.FormFeedback, { style: { display: "block" } }, _this.state.ApplicationValidation.Error)));
                case EditUserEventContentState.Pending:
                    return (React.createElement(Components_1.CustomSpinner, null));
                case EditUserEventContentState.Success:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.Row, { className: "text-success mb-2" },
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faCheckCircle })),
                            React.createElement(reactstrap_1.Col, null)),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" }, _this.props.resources.EditUserSuccessMessage),
                            React.createElement(reactstrap_1.Col, null))));
                case EditUserEventContentState.Error:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.Row, { className: "text-danger mb-2" },
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faTimesCircle })),
                            React.createElement(reactstrap_1.Col, null)),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" }, _this.error.detail || _this.props.resources.AnErrorHasOccurred),
                            React.createElement(reactstrap_1.Col, null))));
            }
        };
        var roles = [];
        var options = userRoles(props.resources);
        _this.props.user.userRole.split(', ').forEach(function (role) {
            var option = options.find(function (o) { return o.value == role; });
            if (option) {
                roles.push(option);
            }
        });
        if (roles.some(function (r) { return r.value == "SuperUser"; })) {
            var adminIndex = roles.findIndex(function (v) { return v.value == "Administrator"; });
            roles[adminIndex].isDisabled = true;
            roles[adminIndex].isFixed = true;
        }
        else {
            options = [options[options.findIndex(function (o) { return o.value == "User"; })], options[options.findIndex(function (o) { return o.value == "Administrator"; })]];
        }
        _this.state = {
            UserData: { DisplayName: props.user.displayName, DefaultLocation: props.user.defaultLocation, Id: props.user.id, Email: props.user.email, TwoFactorAuthentication: props.user.twoFactorAuthentication },
            UserDataValidation: { DisplayName: { Error: "", State: InputValidationState.unset } },
            status: EditUserEventContentState.Initial,
            ApplicationValidation: { Error: "", State: InputValidationState.unset },
            UserRoleSelectOptions: roles,
            SelectOptions: options,
            roles: props.user.userRole
        };
        return _this;
    }
    EditUserEventContent.prototype.render = function () {
        return this.stateBasedRender(this.state.status);
    };
    return EditUserEventContent;
}(React.Component));
//# sourceMappingURL=EditUserEvent.js.map